import { colors } from 'ui/theme/colors';
import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';

export const ProvisionedEmptyState = ({ height = 111, width = 119, ...props }: SvgIconProps) => (
  <SvgIcon
    height={height}
    width={width}
    viewBox="0 0 111 119"
    data-test="get-started-illustration"
    {...props}
  >
    <path
      d="M7.9668 67.1282C7.9668 80.7073 13.3611 93.7302 22.9629 103.332C32.5648 112.934 45.5877 118.328 59.1668 118.328C72.7459 118.328 85.7688 112.934 95.3707 103.332C104.973 93.7302 110.367 80.7073 110.367 67.1282C110.367 53.5491 104.973 40.5262 95.3707 30.9244C85.7688 21.3225 72.7459 15.9282 59.1668 15.9282C45.5877 15.9282 32.5648 21.3225 22.9629 30.9244C13.3611 40.5262 7.9668 53.5491 7.9668 67.1282Z"
      fill={colors.grey5}
    />
    <path
      d="M28.9346 48.6016H38.0955"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
    />
    <path
      d="M23.5906 48.6016H25.8818"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
    />
    <path
      d="M19.7734 48.6016H20.5376"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
    />
    <path
      d="M50.011 102.915H59.1707"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
    />
    <path
      d="M44.667 102.915H46.9569"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
    />
    <path
      d="M40.8501 102.915H41.613"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
    />
    <path
      d="M99.415 61.5747H108.576"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
    />
    <path
      d="M94.071 61.5747H96.361"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
    />
    <path
      d="M90.2542 61.5747H91.0183"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
    />
    <path
      d="M83.488 97.0024H92.6477"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
    />
    <path
      d="M78.144 97.0024H80.434"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
    />
    <path
      d="M74.3271 97.0024H75.0913"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
    />
    <path
      d="M40.8501 35.0171H50.0111"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
    />
    <path
      d="M35.5061 35.0171H37.796"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
    />
    <path
      d="M31.689 35.0171H32.4531"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
    />
    <path
      d="M15.689 71.6545L26.0493 83.538L42.7366 76.5159L19.7542 67.666L15.689 71.6545Z"
      fill="white"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.6404 64.7221C19.849 64.9161 20.0155 65.1506 20.1299 65.4114C20.2442 65.6722 20.3038 65.9537 20.3052 66.2384C20.3065 66.5232 20.2494 66.8052 20.1375 67.067C20.0256 67.3289 19.8612 67.565 19.6545 67.7609L14.8878 72.4418C14.4658 72.8543 13.9024 73.0904 13.3124 73.1021C12.7224 73.1137 12.1501 72.9001 11.7121 72.5045C11.5036 72.3106 11.337 72.076 11.2227 71.8152C11.1084 71.5544 11.0487 71.273 11.0474 70.9882C11.0461 70.7035 11.1031 70.4215 11.215 70.1596C11.3269 69.8978 11.4913 69.6617 11.698 69.4658L16.466 64.7874C16.8875 64.3747 17.4505 64.1381 18.0403 64.126C18.6301 64.1138 19.2023 64.327 19.6404 64.7221Z"
      fill={colors.purple50}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.1453 107.218L28.4608 91.7405L46.391 88.9463L31.7504 108.465L26.1453 107.218Z"
      fill="white"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M33.2506 111.015C33.3193 110.737 33.331 110.449 33.285 110.167C33.2391 109.886 33.1364 109.616 32.9832 109.375C32.83 109.134 32.6296 108.927 32.3939 108.765C32.1583 108.604 31.8923 108.492 31.6122 108.437L25.0407 106.976C24.4673 106.844 23.8649 106.937 23.3584 107.237C22.8518 107.536 22.4798 108.019 22.3194 108.585C22.2502 108.862 22.238 109.151 22.2837 109.433C22.3293 109.715 22.4318 109.984 22.5849 110.225C22.738 110.466 22.9386 110.674 23.1744 110.835C23.4102 110.996 23.6763 111.108 23.9565 111.163L30.5281 112.624C31.1017 112.757 31.7047 112.664 32.2117 112.365C32.7187 112.065 33.0908 111.581 33.2506 111.015Z"
      fill={colors.purple50}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.2881 97.5413C15.9745 98.7637 5.61287 96.2805 2.15687 95.3845C2.03803 95.3537 1.9293 95.2924 1.84142 95.2066C1.75355 95.1209 1.68957 95.0137 1.65583 94.8956C1.62208 94.7776 1.61973 94.6528 1.64902 94.5336C1.6783 94.4144 1.7382 94.3048 1.82279 94.2159C4.26631 91.6431 11.6788 84.1282 15.986 82.9058C21.202 81.4274 26.395 83.5035 27.5828 87.5445C28.7706 91.5854 25.5105 96.0616 20.2881 97.5413Z"
      fill={colors.red20}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.7046 89.6754C26.7046 89.6754 19.8925 96.2969 12.5414 93.4911C12.0097 93.1997 11.6152 92.7093 11.4444 92.1275C11.2735 91.5456 11.3403 90.9198 11.6301 90.3871C16.329 84.1676 25.6858 86.2079 25.6858 86.2079L26.7046 89.6754Z"
      fill={colors.mustard10}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24.3265 81.0256C24.1075 81.2003 23.9455 81.4363 23.8614 81.7036C23.7772 81.9708 23.7747 82.2571 23.8542 82.5257L27.1579 93.7629C27.2362 94.0274 27.3901 94.2634 27.6006 94.4417C27.8112 94.6199 28.0693 94.7328 28.3432 94.7664C30.2747 94.9993 32.4072 95.1619 34.6766 95.2669L29.394 77.3008C27.5393 78.5718 25.8292 79.8224 24.3265 81.0256Z"
      fill={colors.purple50}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M29.394 77.3007L34.6766 95.2667C41.4784 95.5286 48.2898 95.3782 55.0734 94.8162C63.5672 94.1896 71.8087 91.6474 79.1795 87.3804C86.5503 83.1134 92.859 77.2324 97.6321 70.1787C97.8888 69.7985 98.0584 69.3663 98.1287 68.9129C98.1991 68.4596 98.1685 67.9963 98.0391 67.5561C97.9098 67.116 97.6848 66.7098 97.3804 66.3666C97.0759 66.0234 96.6995 65.7517 96.2779 65.5707C88.4616 62.0999 79.9659 60.4274 71.4173 60.6766C62.8686 60.9258 54.4848 63.0904 46.884 67.0107C40.8495 70.0807 35.0086 73.5171 29.394 77.3007Z"
      fill="white"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M83.3921 27.9822C83.3061 27.9886 83.2206 28.0002 83.1361 28.0168C83.3074 27.3694 83.3935 26.7024 83.3921 26.0328C83.3979 25.1315 83.2378 24.2368 82.9197 23.3934C83.9196 22.2362 84.4373 20.7394 84.3661 19.2117C84.3661 16.5237 83.058 14.34 81.4426 14.34C81.4876 12.6481 81.1932 10.9644 80.5769 9.38813C79.9605 7.81189 79.0346 6.37508 77.8539 5.16252C76.6732 3.94996 75.2615 2.98621 73.7022 2.32815C72.1429 1.67009 70.4676 1.33105 68.7751 1.33105C67.0826 1.33105 65.4073 1.67009 63.848 2.32815C62.2887 2.98621 60.877 3.94996 59.6963 5.16252C58.5156 6.37508 57.5897 7.81189 56.9733 9.38813C56.3569 10.9644 56.0626 12.6481 56.1076 14.34C54.4922 14.34 53.1841 16.516 53.1841 19.2117C53.1123 20.7395 53.6301 22.2364 54.6305 23.3934C54.3124 24.2368 54.1523 25.1315 54.1581 26.0328C54.1567 26.7024 54.2428 27.3694 54.4141 28.0168C54.3296 28.0003 54.2441 27.9887 54.1581 27.9822C52.5441 27.9822 51.2346 29.7269 51.2346 31.8798C51.2346 34.0328 52.5441 35.7774 54.1581 35.7774C54.2307 35.7715 54.3029 35.7616 54.3745 35.748C54.2339 36.2327 54.1611 36.7345 54.1581 37.2392C54.1242 38.0199 54.2908 38.7963 54.6422 39.4943C54.9935 40.1923 55.5179 40.7886 56.1652 41.2264C56.2377 41.7695 56.4261 42.2906 56.7174 42.7547C57.0088 43.2187 57.3963 43.6148 57.854 43.9161C58.3116 44.2174 58.8285 44.4169 59.3699 44.5012C59.9113 44.5855 60.4645 44.5526 60.9921 44.4046C60.9921 44.4533 60.978 44.4981 60.978 44.5467C60.978 45.0585 61.0788 45.5654 61.2747 46.0382C61.4705 46.5111 61.7576 46.9408 62.1196 47.3027C62.4815 47.6646 62.9112 47.9517 63.384 48.1476C63.8569 48.3435 64.3637 48.4443 64.8756 48.4443C65.2486 48.4426 65.6195 48.3865 65.9764 48.2779C66.1489 48.8867 66.5153 49.4227 67.0201 49.8043C67.5249 50.1859 68.1404 50.3924 68.7732 50.3924C69.406 50.3924 70.0215 50.1859 70.5263 49.8043C71.031 49.4227 71.3975 48.8867 71.57 48.2779C71.9269 48.3863 72.2977 48.4424 72.6708 48.4443C73.1827 48.4445 73.6897 48.3438 74.1627 48.148C74.6357 47.9522 75.0656 47.6651 75.4276 47.3032C75.7897 46.9412 76.0769 46.5115 76.2729 46.0385C76.4688 45.5656 76.5697 45.0586 76.5697 44.5467C76.5697 44.4981 76.5569 44.4533 76.5543 44.4046C77.082 44.5528 77.6354 44.5859 78.177 44.5017C78.7186 44.4175 79.2359 44.218 79.6937 43.9167C80.1516 43.6154 80.5394 43.2193 80.831 42.7551C81.1225 42.291 81.311 41.7697 81.3837 41.2264C82.0313 40.7888 82.5559 40.1925 82.9075 39.4945C83.259 38.7965 83.4259 38.02 83.3921 37.2392C83.3891 36.7345 83.3163 36.2327 83.1757 35.748C83.2473 35.7617 83.3195 35.7716 83.3921 35.7774C85.0061 35.7774 86.3143 34.0315 86.3143 31.8798C86.3143 29.7281 85.001 27.9822 83.3921 27.9822Z"
      fill={colors.salmon10}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M59.3511 57.0396H78.1863V61.6962H59.3511V57.0396Z"
      fill={colors.mustard10}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M58.2195 63.0056C58.2194 62.4371 58.3389 61.875 58.57 61.3556C58.8012 60.8362 59.1389 60.3712 59.5613 59.9907C59.9837 59.6101 60.4813 59.3226 61.0219 59.1468C61.5625 58.9709 62.1341 58.9106 62.6995 58.9698C63.7238 59.1111 64.6605 59.624 65.3314 60.4108C66.0024 61.1976 66.3608 62.2035 66.3385 63.2373V81.4568C66.3385 81.8873 66.1675 82.3001 65.8631 82.6045C65.5588 82.9089 65.1459 83.0799 64.7155 83.0799H58.2195V63.0056Z"
      fill={colors.mustard10}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M58.2824 83.0798C58.0042 83.0823 57.7301 83.013 57.4864 82.8786C57.2428 82.7443 57.038 82.5494 56.8917 82.3127C56.7454 82.0761 56.6626 81.8058 56.6512 81.5278C56.6399 81.2498 56.7005 80.9736 56.827 80.7259C57.2476 79.9638 57.8649 79.3285 58.6146 78.8863C59.3644 78.4442 60.219 78.2112 61.0894 78.2119H61.901C62.7567 78.2099 63.5979 78.4337 64.3396 78.8607C65.0812 79.2877 65.6971 79.9028 66.125 80.6439C66.2673 80.8907 66.3421 81.1706 66.3419 81.4555C66.3416 81.7404 66.2664 82.0202 66.1236 82.2667C65.9809 82.5133 65.7757 82.7179 65.5288 82.8599C65.2818 83.002 65.0018 83.0765 64.717 83.0759L58.2824 83.0798Z"
      fill={colors.purple10}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M74.8827 59.026C75.4228 58.9201 75.9788 58.9252 76.5169 59.0409C77.055 59.1567 77.5639 59.3806 78.0126 59.6993C78.4614 60.0179 78.8407 60.4245 79.1273 60.8943C79.414 61.3641 79.6021 61.8873 79.6802 62.4321C79.7937 63.4934 79.5 64.5583 78.8585 65.4113C78.2169 66.2644 77.2754 66.842 76.2242 67.0273L58.1442 70.6011L56.8872 64.2331C56.8041 63.8104 56.8923 63.3721 57.1323 63.0144C57.3723 62.6568 57.7446 62.4091 58.1672 62.3259L74.8827 59.026Z"
      fill={colors.mustard10}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M56.8872 64.2331C56.832 63.9536 56.8513 63.6645 56.9432 63.3948C57.0352 63.1251 57.1964 62.8844 57.4109 62.6969C57.6253 62.5093 57.8853 62.3814 58.1648 62.3262C58.4443 62.271 58.7334 62.2903 59.0031 62.3822C59.8114 62.6584 60.5327 63.1427 61.0945 63.7862C61.6562 64.4297 62.0386 65.2099 62.2031 66.0481L62.3605 66.8443C62.5317 67.6987 62.4702 68.5835 62.1824 69.406C61.8947 70.2286 61.3912 70.9587 60.7247 71.5201C60.5061 71.6925 60.2467 71.8055 59.9716 71.8483C59.6965 71.8911 59.4151 71.8621 59.1545 71.7643C58.8938 71.6665 58.6629 71.5031 58.4839 71.2899C58.3049 71.0767 58.1839 70.8209 58.1327 70.5473L56.8872 64.2331Z"
      fill={colors.purple10}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M79.3179 48.424C79.5037 50.0709 80.2882 51.5921 81.5222 52.6984C82.7562 53.8048 84.3537 54.4191 86.011 54.4247C87.5685 54.4199 89.0786 53.8882 90.2955 52.916C91.5125 51.9439 92.3645 50.5885 92.7131 49.0704L94.2593 41.8487C94.3715 41.3155 94.3148 40.7607 94.0971 40.2613C93.8794 39.7619 93.5115 39.3428 93.0446 39.0621V38.6064H91.4804C92.0014 37.5632 91.2782 34.3619 89.4529 34.3619C89.2804 34.3566 89.1085 34.3867 88.948 34.4503C88.7875 34.5139 88.6417 34.6097 88.5197 34.7317C88.3976 34.8538 88.3018 34.9996 88.2382 35.1601C88.1746 35.3206 88.1445 35.4924 88.1499 35.665C88.1499 36.4471 88.6708 36.4471 88.6708 38.5335C88.6702 39.1213 88.6304 39.7084 88.5518 40.2909C88.5195 40.5273 88.5369 40.7678 88.603 40.9971C88.6692 41.2263 88.7825 41.4392 88.9358 41.6221L87.5764 47.9683C87.4971 48.3344 87.2855 48.6584 86.9822 48.8783C86.6789 49.0981 86.3052 49.1984 85.9325 49.1599C85.5599 49.1214 85.2146 48.9468 84.9627 48.6695C84.7107 48.3923 84.5699 48.0319 84.5671 47.6573L79.3179 48.424Z"
      fill="white"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M52.5505 48.3519V60.5119C52.5505 60.8817 52.6234 61.2479 52.7649 61.5896C52.9064 61.9312 53.1138 62.2417 53.3753 62.5031C53.6368 62.7646 53.9472 62.9721 54.2889 63.1136C54.6306 63.2551 54.9967 63.3279 55.3665 63.3279H55.4011C56.1479 63.3279 56.8642 63.0312 57.3923 62.5031C57.9204 61.975 58.2171 61.2588 58.2171 60.5119V48.1279L52.5505 48.3519Z"
      fill="white"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M92.5404 42.9645C92.1801 42.8372 91.852 42.6329 91.5788 42.3658C91.3056 42.0987 91.094 41.7752 90.9586 41.418C90.8232 41.0607 90.7674 40.6782 90.7949 40.2971C90.8225 39.9161 90.9329 39.5456 91.1183 39.2115C91.4461 38.6626 91.9566 38.2464 92.5603 38.0358C93.164 37.8253 93.8225 37.8336 94.4207 38.0595L95.3602 38.3911C95.5474 38.4571 95.7196 38.5595 95.8669 38.6926C96.0142 38.8256 96.1337 38.9866 96.2183 39.1661C96.303 39.3457 96.3512 39.5402 96.3601 39.7385C96.369 39.9368 96.3385 40.1349 96.2703 40.3213L95.4959 42.4346C95.3598 42.8048 95.0833 43.1066 94.7263 43.2743C94.3693 43.442 93.9605 43.4622 93.5887 43.3306L92.5404 42.9645Z"
      fill="white"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M84.9818 46.4781C85.0008 44.3365 84.5955 42.2123 83.7891 40.2282C82.9827 38.2442 81.7913 36.4395 80.2836 34.9184C78.776 33.3973 76.9819 32.1899 75.0051 31.3659C73.0283 30.5419 70.9078 30.1177 68.7661 30.1177C66.6244 30.1177 64.504 30.5419 62.5271 31.3659C60.5503 32.1899 58.7563 33.3973 57.2486 34.9184C55.741 36.4395 54.5496 38.2442 53.7432 40.2282C52.9368 42.2123 52.5314 44.3365 52.5504 46.4781V49.76C52.7098 49.6686 52.8903 49.6205 53.074 49.6205H58.304C58.4415 49.6203 58.5776 49.6472 58.7046 49.6997C58.8317 49.7522 58.9471 49.8292 59.0443 49.9263C59.1416 50.0234 59.2187 50.1388 59.2714 50.2657C59.324 50.3927 59.3511 50.5288 59.3511 50.6662V57.0432H78.1812V50.6624C78.1812 50.525 78.2083 50.3889 78.2609 50.2619C78.3135 50.1349 78.3907 50.0196 78.4879 49.9225C78.5852 49.8253 78.7006 49.7483 78.8276 49.6959C78.9546 49.6434 79.0908 49.6165 79.2282 49.6166L84.9818 46.4781Z"
      fill={colors.salmon20}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M68.7667 30.2618C66.3339 30.2584 63.9318 30.8045 61.7395 31.8593L65.9635 34.3335C66.0903 34.4082 66.2002 34.5084 66.2861 34.6279L68.256 37.3863C68.3144 37.4675 68.3914 37.5335 68.4804 37.5791C68.5694 37.6247 68.668 37.6485 68.768 37.6485C68.868 37.6485 68.9666 37.6247 69.0556 37.5791C69.1446 37.5335 69.2215 37.4675 69.28 37.3863L71.2499 34.6279C71.3358 34.5084 71.4456 34.4082 71.5725 34.3335L75.7965 31.8593C73.6052 30.799 71.201 30.2526 68.7667 30.2618Z"
      fill="white"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M78.0297 49.0661L83.8713 44.656L85.7611 47.1608L79.9195 51.5709L78.0297 49.0661Z"
      fill={colors.purple50}
      stroke={colors.purple100}
      strokeWidth="1.27948"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M52.0283 49.6167H59.3512V52.7553H52.0283V49.6167Z"
      fill={colors.purple50}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M78.1812 50.6625V47.1719C78.1813 45.685 78.5405 44.2202 79.2282 42.9019"
      fill="white"
    />
    <path
      d="M78.1812 50.6625V47.1719C78.1813 45.685 78.5405 44.2202 79.2282 42.9019V42.9019"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M59.351 50.6625V47.1719C59.3508 45.685 58.9916 44.2202 58.304 42.9019" fill="white" />
    <path
      d="M59.351 50.6625V47.1719C59.3508 45.685 58.9916 44.2202 58.304 42.9019V42.9019"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M63.2475 38.2261C63.4628 38.3336 63.7119 38.3513 63.9402 38.2752C64.1684 38.1991 64.3571 38.0355 64.4648 37.8203L66.1403 34.4693C66.0848 34.4176 66.0239 34.3721 65.9586 34.3336L61.7346 31.8594C60.492 32.4586 59.3307 33.2135 58.2786 34.1058C59.5968 35.8423 61.297 37.2521 63.2475 38.2261Z"
      fill={colors.purple50}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M74.2849 38.2261C74.1784 38.2793 74.0625 38.3111 73.9437 38.3195C73.825 38.3279 73.7058 38.3128 73.5928 38.2751C73.4799 38.2375 73.3755 38.1779 73.2856 38.0999C73.1957 38.0218 73.1221 37.9268 73.0689 37.8203L71.3921 34.4693C71.4478 34.4179 71.5088 34.3725 71.5738 34.3336L75.7979 31.8594C77.0404 32.4586 78.2018 33.2135 79.2538 34.1058C77.9356 35.8423 76.2354 37.2521 74.2849 38.2261Z"
      fill={colors.purple50}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M73.0164 30.8249C72.7454 30.7508 72.5064 30.5895 72.3361 30.3661C72.1659 30.1426 72.0739 29.8694 72.0743 29.5885V24.9805H65.6V29.5526C65.5997 29.8352 65.5058 30.1098 65.3331 30.3334C65.1604 30.5571 64.9185 30.7173 64.6452 30.7891C63.6444 31.0522 62.6711 31.4101 61.7383 31.8579L65.9623 34.3321C66.0891 34.4068 66.199 34.5071 66.2848 34.6265L68.2548 37.3849C68.3132 37.4661 68.3901 37.5322 68.4792 37.5778C68.5682 37.6233 68.6667 37.6471 68.7668 37.6471C68.8668 37.6471 68.9654 37.6233 69.0544 37.5778C69.1434 37.5322 69.2203 37.4661 69.2788 37.3849L71.2487 34.6265C71.3346 34.5071 71.4444 34.4068 71.5712 34.3321L75.7952 31.8579C74.9012 31.4324 73.9713 31.0868 73.0164 30.8249Z"
      fill="white"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M78.514 17.2633V15.968C78.514 15.7197 78.505 15.4739 78.4871 15.2294C77.7811 15.2144 77.1089 14.9241 76.614 14.4205C76.119 13.9169 75.8403 13.2399 75.8375 12.5337C69.6628 12.9869 66.8212 9.4707 66.8212 9.4707C66.5054 9.93506 66.0784 10.313 65.5792 10.5701C65.08 10.8272 64.5243 10.9553 63.9629 10.9427C63.7096 10.8939 63.449 10.8967 63.1967 10.9508C62.9444 11.005 62.7057 11.1095 62.4947 11.258C62.2837 11.4065 62.1048 11.596 61.9686 11.8152C61.8325 12.0344 61.742 12.2788 61.7025 12.5337C61.6993 13.2398 61.4205 13.9167 60.9256 14.4202C60.4307 14.9237 59.7587 15.2141 59.0528 15.2294C59.0349 15.4739 59.026 15.7197 59.026 15.968V17.2672C58.5527 17.3562 58.1279 17.6139 57.8302 17.9923C57.5325 18.3708 57.3822 18.8445 57.4072 19.3253C57.4322 19.8062 57.6308 20.2617 57.9662 20.6073C58.3015 20.9528 58.7509 21.165 59.2308 21.2045C59.6881 23.3961 60.8861 25.3634 62.6233 26.7756C64.3606 28.1878 66.5311 28.9587 68.77 28.9587C71.0088 28.9587 73.1794 28.1878 74.9166 26.7756C76.6539 25.3634 77.8519 23.3961 78.3092 21.2045C78.7891 21.165 79.2384 20.9528 79.5738 20.6073C79.9091 20.2617 80.1077 19.8062 80.1327 19.3253C80.1577 18.8445 80.0075 18.3708 79.7098 17.9923C79.4121 17.6139 78.9872 17.3562 78.514 17.2672V17.2633Z"
      fill="white"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M62.2734 20.43C62.2734 20.7532 62.4018 21.0631 62.6303 21.2916C62.8589 21.5202 63.1688 21.6485 63.492 21.6485C63.8152 21.6485 64.1251 21.5202 64.3536 21.2916C64.5822 21.0631 64.7106 20.7532 64.7106 20.43C64.7106 20.1068 64.5822 19.7969 64.3536 19.5683C64.1251 19.3398 63.8152 19.2114 63.492 19.2114C63.1688 19.2114 62.8589 19.3398 62.6303 19.5683C62.4018 19.7969 62.2734 20.1068 62.2734 20.43Z"
      fill={colors.red20}
    />
    <path
      d="M72.8296 20.43C72.8296 20.7532 72.958 21.0631 73.1865 21.2916C73.415 21.5202 73.725 21.6485 74.0481 21.6485C74.3713 21.6485 74.6813 21.5202 74.9098 21.2916C75.1383 21.0631 75.2667 20.7532 75.2667 20.43C75.2667 20.1068 75.1383 19.7969 74.9098 19.5683C74.6813 19.3398 74.3713 19.2114 74.0481 19.2114C73.725 19.2114 73.415 19.3398 73.1865 19.5683C72.958 19.7969 72.8296 20.1068 72.8296 20.43Z"
      fill={colors.red20}
    />
    <path
      d="M73.1611 17.5872C72.9017 17.3284 72.5502 17.1831 72.1838 17.1831C71.8174 17.1831 71.4659 17.3284 71.2065 17.5872"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M64.3789 17.5872C64.6383 17.3284 64.9898 17.1831 65.3562 17.1831C65.7226 17.1831 66.0741 17.3284 66.3335 17.5872"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M71.2065 23.272C70.5037 23.7995 69.6487 24.0846 68.77 24.0846C67.8913 24.0846 67.0363 23.7995 66.3335 23.272"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
